import React, { useState, useEffect } from 'react';
import { RefreshCw, FileText, AlertCircle, ChevronDown, ChevronUp, Loader } from 'lucide-react';
import './AzureFilesList.css';
import { useApiWithAuth } from '../hooks/useApiWithAuth';
import { API_BASE_URL } from '../config';

const AzureFilesList = ({ onStartProcessing, processingLoading }) => {
  const { fetchWithAuth } = useApiWithAuth();
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const fetchFiles = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetchWithAuth(`${API_BASE_URL}/list-inbound`);
      const result = await response.json();
      
      if (result.success) {
        setFiles(result.files);
      } else {
        setError(result.message || 'Failed to fetch files');
      }
    } catch (err) {
      setError('Network error: Could not connect to server');
    } finally {
      setIsLoading(false);
    }
  };

  /* eslint-disable */
  useEffect(() => {
    fetchFiles();
  }, []);

  const handleRefresh = () => {
    fetchFiles();
  };

  const handleStartProcessing = () => {
    if (files.length > 0) {
      onStartProcessing(files);
    }
  };

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="azure-files-list">
      <div className="files-header" onClick={toggleCollapse} style={{ cursor: 'pointer' }}>
        <div className="title-section">
          <FileText size={24} />
          <h3>Invoices Received</h3>
        </div>
        <div className="header-actions">
          <button 
            className={`refresh-button ${isLoading ? 'loading' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              handleRefresh();
            }}
            disabled={isLoading}
          >
            <RefreshCw size={18} />
            Refresh
          </button>
          {isCollapsed ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
        </div>
      </div>

      {!isCollapsed && (
        <>
          {error && (
            <div className="error-message">
              <AlertCircle size={18} />
              <span>{error}</span>
            </div>
          )}

          <div className="files-container">
            {files.length > 0 ? (
              <>
                <div className="files-list">
                  {files.map((file, index) => (
                    <div key={index} className="file-item">
                      <FileText size={16} />
                      <span className="file-name">{file}</span>
                    </div>
                  ))}
                </div>
                <button 
                  className="process-button"
                  onClick={handleStartProcessing}
                  disabled={processingLoading}
                >
                  {processingLoading ? <Loader size={18} className="spinning" /> : 'Start Processing Files'}
                </button>
              </>
            ) : (
              <div className="no-files">
                <p>No files found in Azure inbound folder</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AzureFilesList;